import { createDataAttribute } from "@sanity/visual-editing";

const projectId = process.env.REACT_APP_SANITY_PROJECT_ID;
const dataset = process.env.REACT_APP_SANITY_DATASET || "production";

// Usage: editAttr(documentId, `sections[_key=="${sectionKey}"].heading`)
export function editAttr(documentId, path) {
  if (!documentId || !path) return {};
  const attr = createDataAttribute({
    projectId,
    dataset,
    id: documentId,
    type: "page",
    path,
  });
  return { "data-sanity": attr.toString() };
}
